<div class="flex-row w-100 portal-header">
  <div class="flex-row ps-3 element-hover">
    <img src="assets/img/filings_summary_logo.png" width="207px" height="40px" alt=""
         (mousedown)="handleMiddleClick($event)" (click)="backToMainPage()">
    <i class="fa fa-search ms-2 line-height" *ngIf="displaySearchIcon" (click)="openSearchPanelClick()"></i>
    <i class="fa fa-calendar ms-2 line-height" *ngIf="displayCalendarIcon" (click)="backToMainPage()"></i>
  </div>
  <div class="flex-row w-100 text-end" *ngIf="displayRightMenu">
    <div class="w-100 text-end">
      <i class="fa fa-question-circle mt-2 me-2" (click)="openContactUs()"></i>
      <i class="fa fa-user fs-user mt-2 me-2 ms-1" [matMenuTriggerFor]="menu"></i>
      <mat-menu #menu="matMenu" class="flex-column styled">
        <div class="menu-div main-text-font" routerLink="/">
          <span class="fa fa-home black"></span>
          Home
        </div>
        <app-cached-files-menuitem>
        </app-cached-files-menuitem>
        <div class="menu-div main-text-font" (click)="openChangePasswordPopup()">
          <span class="fa fa-edit black"></span>
          Change Password
        </div>
        <div class="menu-div main-text-font" routerLink="/logout">
          <span class="fa fa-power black"></span>
          Logout
        </div>
      </mat-menu>
    </div>
  </div>
  <div *ngIf="displayRightLogo" class="w-100 text-end me-2 mt-1">
    <a href="https://dpcdata.com/" target="_blank">
      <img src="assets/img/dpc_logo_fp.png" width="150px" height="30px" alt="DPC DATA Logo">
    </a>
  </div>
</div>

